import type { AssetTypeDefinition } from './assetTypes'
import { findAssetTypeById, findAssetTypeByLabel } from './assetTypes'
import type { AssetEntityTypeConfig } from './useAssetTypeRegistry'

type AssetEntityTypeConfigLike = Pick<AssetEntityTypeConfig, 'allowedTypes' | 'allowedTypeIds' | 'typeFieldId'>
const FEATURE_EXPORT_PATTERN = /\bexport\s+default\b/
const FEATURE_RUNTIME_PATTERN = /\btrellis\b|\bReact\./

export const resolveAssetTypeFromLabel = (
  typeLabel?: string,
  assetConfig?: AssetEntityTypeConfigLike
): AssetTypeDefinition | undefined => {
  if (!assetConfig) {
    return typeLabel ? findAssetTypeByLabel(typeLabel) : undefined
  }

  if (assetConfig.allowedTypes.length === 1 && !assetConfig.typeFieldId) {
    return assetConfig.allowedTypes[0]
  }

  if (!typeLabel) {
    return assetConfig.allowedTypes.length === 1 ? assetConfig.allowedTypes[0] : undefined
  }

  const resolved = findAssetTypeByLabel(typeLabel)
  if (!resolved) return undefined
  return assetConfig.allowedTypeIds.includes(resolved.id) ? resolved : undefined
}

export const inferFeatureAssetType = (
  assetType: AssetTypeDefinition | undefined,
  content: string
): AssetTypeDefinition | undefined => {
  if (assetType) return assetType

  const source = String(content || '')
  if (!FEATURE_EXPORT_PATTERN.test(source)) return undefined
  if (!FEATURE_RUNTIME_PATTERN.test(source)) return undefined

  return findAssetTypeById('feature')
}
